import { NavLink, useLocation } from 'react-router-dom';
import React from 'react';

const FilterNav = ({ activeTab, setActiveTab }) => {
  const location = useLocation();

  // Helper function to determine if a link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="category_listbox">
      <div className="container">
        <div className="category_box">
          <ul>
            <li onClick={() => setActiveTab('all_crypto')} className={activeTab === 'all_crypto' ? 'active' : ''}>
              <NavLink >All Crypto</NavLink>
            </li>
            <li onClick={() => setActiveTab('top_gainers')} className={activeTab === 'top_gainers' ? 'active' : ''}>
              <NavLink >Top Gainers</NavLink>
            </li>
            <li onClick={() => setActiveTab('top_losers')} className={activeTab === 'top_losers' ? 'active' : ''}>
              <NavLink >Top Losers</NavLink>
            </li>
            <li onClick={() => setActiveTab('trending')} className={activeTab === 'trending' ? 'active' : ''}>
              <NavLink >♻️ Trending</NavLink>
            </li>
            <li onClick={() => setActiveTab('top_marketcap')} className={activeTab === 'top_marketcap' ? 'active' : ''}>
              <NavLink >🔥 Top Market Cap</NavLink>
            </li>
            <li onClick={() => setActiveTab('defi')} className={activeTab === 'defi' ? 'active' : ''}>
              <NavLink >🔥 DeFi</NavLink>
            </li>
            <li onClick={() => setActiveTab('nft')} className={activeTab === 'nft' ? 'active' : ''}>
              <NavLink >🔥 NFT</NavLink>
            </li>
            <li onClick={() => setActiveTab('ai')} className={activeTab === 'ai' ? 'active' : ''}>
              <NavLink >🤖 AI Tokens</NavLink>
            </li>
            <li onClick={() => setActiveTab('meme')} className={activeTab === 'meme' ? 'active' : ''}>
              <NavLink >🐶 Meme</NavLink>
            </li>            
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FilterNav;    